import { post,put,get,deleteRequest, postfd } from "../../../helpers/apihelpers";

export const UploadInvestmentBuildingAttachmentService=async(data)=>{
    try {
        const result = await postfd(`api/database/investment_building/upload_file`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CreateInvestmentBuildingService=async(data)=>{
    try {
        const result = await post(`api/database/investment_building/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateInvestmentBuildingService=async(data,id)=>{
    try {
        const result = await put(`api/database/investment_building/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetInvestmentBuildingService=async(page,from_date,to_date,text,step,)=>{
    try {
        const result = await get(`api/database/investment_building/get?page=${page}&from_date=${from_date}&to_date=${to_date}&text=${text}&step=${step}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetInvestmentBuildingDetailService=async(id)=>{
    try {
        const result = await get(`api/database/investment_building/get/${id}`,);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteInvestmentBuildingService=async(id)=>{
    try {
        const result = await deleteRequest(`api/database/investment_building/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteAdminInvestmentBuildingService=async(id)=>{
    try {
        const result = await deleteRequest(`api/database/investment_building/delete_admin/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteMassInvestmentBuildingService=async(data)=>{
    try {
        const result = await post(`api/database/investment_building/deleteMassMany`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const FilterInvestmentBuildingService=async(id)=>{
    try {
        const result = await get(`api/database/investment_building/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadInvestmentBuildingExcelService=async(data)=>{
    try {
        const result = await postfd(`api/database/investment_building/upload_excel`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UploadInvestmentBuildingExcelService1=async(data)=>{
    try {
        const result = await postfd(`api/database/investment_building/upload_excel1`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GenerateInvestmentBuildingPPTService=async(data)=>{
    try {
        const result = await post(`api/database/investment_building/generate_ppt`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const GetInvestmentBuildingHistoryService=async(page,id)=>{
    try {
        const result = await get(`api/database/investment_building/investment_building_history/${id}?page=${page}`);
        return result;
    } catch (err) {
        return err.response;
    } 
}

export const UpdateInvestmentBuildingHistoryService=async(id,data)=>{
    try {
        const result = await put(`api/database/investment_building/investment_building_history/${id}`,data);
        return result;
    } catch (err) {
        return err.response;
    } 
}

export const DeleteInvestmentBuildingHistoryService=async(id)=>{
    try {
        const result = await deleteRequest(`api/database/investment_building/investment_building_history/${id}`);
        return result;
    } catch (err) {
        return err.response;
    } 
}